/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Mixin to provide model-field level permissions on the serializer level.
 * 
 * How to use:
 *     1. Add the mixin as the first inherited class to your serializer (at
 *        least before the SerializerExtensionsMixin).
 *     2. Make sure that Meta.model is specified on your serializer.
 *     3. Define a 'get_forbidden_fields' classmethod on the according model
 *        class that returns a list of fieldnames for all fields that a user
 *        is *not* allowed to view/edit. Example:
 * 
 *             @classmethod
 *             def get_forbidden_fields(cls, action: Literal["view", "create", "edit"],
 *                                      user) -> List[str]:
 *                 if action == "view":
 *                     if user.is_staff: return []
 * 
 *                     # for all other users
 *                     return [
 *                         "forbidden_field_name_1",
 *                         "forbidden_field_name_2,
 *                     ]
 *                 if action == "create":
 *                     pass
 *                 if action == "edit":
 *                     pass
 *                 return []
 * 
 * 
 * How to use with expandable fields:
 *     1. Setup the HyperlinkedRelatedField as usual.
 *     2. Add the field that relies on you permission-enriched serializer to
 *        the 'expandable_fields' dict and point it to 'SerializerMethodField'.
 *        (from rest_framework.serializers import SerializerMethodField)
 *     3. Add a serializer method with the name 'get_<expandable_field_name>'
 *        to the serializer that holds the expandable field.
 * 
 *     Example:
 * 
 *             class SerializerB( FieldLevelPermissionSerializerMixin,
 *                                SerializerExtensionMixin,
 *                                HyperlinkedModelSerializer):
 *                 class Meta:
 *                     model=B
 * 
 *             class SerializerA(SerializerExtensionMixin, HyperlinkedModelSerializer):
 *                 field_b = HyperlinkedRelatedField(
 *                     view_name="View-B-detail",
 *                     ...
 *                 )
 * 
 *                 get_field_b(self, obj):
 *                     "   Helper method that provides the nested serializer
 *                         SerializerB with the required information for
 *                         the FieldLevelPermissionSerializerMixin to work.
 *                        "
 *                     return SerializerB(context={
 *                         "request": self.context["request"],
 *                         "view": self.context["view"],
 *                         "expand": [
 *                             # prepare the argument for the next serializer
 *                             expand_arg.removeprefix("field_b__")
 *                             for expand_arg
 *                             in self.context["expand"]
 *                             # remove any arguments that are meant for the current serializer
 *                             if expand_arg.startswith("field_b__")
 *                         ],
 *                     }).to_representation(obj.field_b)
 * 
 *                 class Meta:
 *                     model=A
 *                     expandable_fields=dict(
 *                         field_a=SerializerMethodField
 *                     )
 * @export
 * @interface APIGuestRequestRequest
 */
export interface APIGuestRequestRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof APIGuestRequestRequest
     */
    editors?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestRequest
     */
    company: string;
    /**
     * Quantities listed as string and separated by comma like '1,2,3'
     * @type {string}
     * @memberof APIGuestRequestRequest
     */
    quantity: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestRequest
     */
    material: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestRequest
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestRequest
     */
    remarks?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestRequest
     */
    status?: string | null;
}

/**
 * Check if a given object implements the APIGuestRequestRequest interface.
 */
export function instanceOfAPIGuestRequestRequest(value: object): value is APIGuestRequestRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('material' in value) || value['material'] === undefined) return false;
    return true;
}

export function APIGuestRequestRequestFromJSON(json: any): APIGuestRequestRequest {
    return APIGuestRequestRequestFromJSONTyped(json, false);
}

export function APIGuestRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIGuestRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'editors': json['editors'] == null ? undefined : json['editors'],
        'name': json['name'],
        'email': json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'company': json['company'],
        'quantity': json['quantity'],
        'material': json['material'],
        'message': json['message'] == null ? undefined : json['message'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function APIGuestRequestRequestToJSON(value?: APIGuestRequestRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'editors': value['editors'],
        'name': value['name'],
        'email': value['email'],
        'phone': value['phone'],
        'company': value['company'],
        'quantity': value['quantity'],
        'material': value['material'],
        'message': value['message'],
        'remarks': value['remarks'],
        'status': value['status'],
    };
}

